import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { SETTINGS_TABS } from '../../settings-tabs.constants';
import * as settingsActions from '../actions/settings.actions';
import { SettingsService } from '../service/settings.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly settingsService: SettingsService = inject(SettingsService);

  loadSettingsTabs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.loadSettingsTabs),
      map(() =>
        settingsActions.loadSettingsTabsSuccess({ tabs: SETTINGS_TABS }),
      ),
    ),
  );

  updateProfileInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.updateProfileInfo),
      switchMap((action) =>
        this.settingsService
          .updateProfileInfo(action.userId, action.payload)
          .pipe(
            map(() => settingsActions.updateProfileInfoSuccess()),
            catchError(() => of(settingsActions.updateProfileInfoError())),
          ),
      ),
    ),
  );

  sendDeleteVerificationCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.sendDeleteVerificationCode),
      switchMap((action) =>
        this.settingsService
          .sendDeleteVerificationCode(action.userId, action.emailId)
          .pipe(
            map(() => settingsActions.sendDeleteVerificationCodeSuccess()),
            catchError(() =>
              of(settingsActions.sendDeleteVerificationCodeError()),
            ),
          ),
      ),
    ),
  );

  deleteAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(settingsActions.deleteAccount),
      switchMap((action) =>
        this.settingsService
          .deleteAccount(action.userId, action.emailId, action.verificationCode)
          .pipe(
            map(() => settingsActions.deleteAccountSuccess()),
            catchError((err) =>
              of(
                settingsActions.deleteAccountError({
                  errorMessage:
                    err?.error?.message ??
                    'Failed to delete account. Please try again.',
                }),
              ),
            ),
          ),
      ),
    ),
  );
}
